import { RootContainer } from "../../../../core/root_container";
import { SearchwordSuggestionAction } from "../../actions/searchword_suggestion_action";
import { KeywordDetailJsEnv } from "../../models/keyword_detail_js_env";
import { SearchwordSuggestion } from "./searchword_suggestion";

export class SearchwordSuggestionContainer extends RootContainer<KeywordDetailJsEnv> {
  constructor() {
    super();
    this.mount(SearchwordSuggestion, 'searchwordSuggestionContents');

    SearchwordSuggestionAction.UPDATE_EVENT.on((model: KeywordDetailJsEnv) => {
      this.update(model);

      if (model.historySuggest?.shouldShow || model.suggest?.shouldShow) {
        SearchwordSuggestionContainer.showSuggest();
      } else {
        SearchwordSuggestionContainer.hideSuggest();
      }
    });

    const searchwordElement = document.getElementById('searchword');
    searchwordElement?.addEventListener('input', (event: Event) => {SearchwordSuggestionAction.updateSuggest(SearchwordSuggestionContainer.getValueFromEvent(event))});
    searchwordElement?.addEventListener('focus', (event: Event) => {SearchwordSuggestionAction.updateSuggest(SearchwordSuggestionContainer.getValueFromEvent(event))});
    searchwordElement?.addEventListener('keydown', (event: KeyboardEvent) => {SearchwordSuggestionContainer.hideSuggestByShiftTab(event)});
    document.addEventListener('click', (event: Event) => {
      const { target } = event;
      if (!(target as HTMLElement).closest('#searchwordContent')) {
        SearchwordSuggestionContainer.hideSuggest();
      }
    });
  }

  private static SHOWN_CLASS = 'is-shown';
  private static ARIA_HIDDEN = 'aria-hidden';

  private static showSuggest() {
    document.getElementById('searchwordContent')?.classList.add(this.SHOWN_CLASS);
    document.getElementById('searchwordSuggestion')?.setAttribute(this.ARIA_HIDDEN, 'false');
  }

  static hideSuggest() {
    document.getElementById('searchwordContent')?.classList.remove(this.SHOWN_CLASS);
    document.getElementById('searchwordSuggestion')?.setAttribute(this.ARIA_HIDDEN, 'true');
  }

  private static hideSuggestByShiftTab = (event: KeyboardEvent) => {
    if (event.key === 'Tab' && event.shiftKey && !event.altKey && !event.ctrlKey && !event.metaKey) {
      SearchwordSuggestionContainer.hideSuggest();
    }
  }

  static setSuggestWord = (selectedSuggestWord: string) => {
    const searchword = document.getElementById('searchword') as HTMLInputElement;
    searchword.value = selectedSuggestWord;
  }

  private static getValueFromEvent(event: Event) {
    const { target } = event;
    return (target as HTMLInputElement).value;
  }
}
